export class CtnLookupModel {
  modalHeader: string;
  modalMessage: string;
  ctnFieldLabel: string;
  ctnlookupButtonMessage: string;
  cancelButtonMessage: string;

  constructor() {
    this.modalHeader = 'Search for a wireless number';
    this.modalMessage = 'To see the status of a particular device, enter a wireless number.';
    this.ctnFieldLabel = 'Enter a 10-digit number';
    this.ctnlookupButtonMessage = 'Search';
    this.cancelButtonMessage = 'Cancel';
  }
}
